import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { GlobalProvider } from './context/GlobalContext.js';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { ModalsProvider } from '@mantine/modals';
import modals from './lib/modals.js';
import { Toaster } from 'react-hot-toast';

const theme = createTheme({
  /** Put your mantine theme override here */
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <ModalsProvider modals={modals}>
        <GlobalProvider>
          <Router>
            <App />
            <Toaster />
          </Router>
        </GlobalProvider>
      </ModalsProvider>
    </MantineProvider>
  </React.StrictMode>
);